import { render, staticRenderFns } from "./Transporte.vue?vue&type=template&id=a1a37a52&"
import script from "./Transporte.vue?vue&type=script&lang=ts&"
export * from "./Transporte.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports